import React, { Component } from 'react';
import { Dropdown, DropdownButton, OverlayTrigger, Tooltip, Image } from 'react-bootstrap';
import InfoIcon from '../../Images/info.png';

const ecommOptions = (props) => {

  let { coins_settings } = props;
  const { ecomm } = props.traductions;
  let { auto_vex } = coins_settings[Object.keys(coins_settings)[0]] || props

  const optionStyle = (state,id) =>{
    if(state == id) return 'ecommerce_multi_option active'
    else return 'ecommerce_multi_option'
  }
  const changeVEX = (value) => {
    Object.keys(coins_settings).forEach((item, i) => {
      coins_settings[item].auto_vex = value
    });
    props.setState({coins_settings, auto_vex:value})
  }

  const renderDropwdown = () => {
    return props.list_banks.map(i =>{
      return(
        <Dropdown.Item onClick={()=>props.setState({fiat_bank:i.uuid})} >{i.bank_name} {i.bank_number_account}</Dropdown.Item>
      )
    })
  }

  const findBank = () => {
    let bank = props.list_banks.find(item => item.uuid == props.fiat_bank)
    if(bank) return bank.bank_name + ' ' + bank.bank_number_account
    else return 'Selecciona un banco'
  }
  
  return(
    <>
      {
        !props.noBank ?
        <div>
          <p className='ecommerce_input_label'>{ecomm.banks}</p>
          <DropdownButton className="invoices_dropdown"  style={{width:'100%', marginBottom:15}} title={findBank()}>
            {renderDropwdown()}
          </DropdownButton>


          <p className='ecommerce_input_label'>{ecomm.select_withdrawal}</p>
          <div className='space-between'>
            <div
              className={optionStyle(props.fiat_interval,'daily')}
              onClick={()=>props.setState({auto_fiat:'enabled',fiat_interval:'daily'})}
              >
              {ecomm.daily}
            </div>
            <div
              className={optionStyle(props.fiat_interval,'48')}
              onClick={()=>props.setState({auto_fiat:'enabled',fiat_interval:'48'})}
              >
              {ecomm['48']}
            </div>
            <div
              className={optionStyle(props.auto_fiat,'disabled')}
              onClick={()=>props.setState({auto_fiat:'disabled',fiat_interval:0 })}
              >
              {ecomm.auto.disabled}
            </div>
          </div>
        </div>
        :
          <p className='ecommerce_input_label'>
            {ecomm.fiat_alert}
            <a target="_blank" href={'/kyc'}>{ecomm.kyc}</a>
            {ecomm.fiat_alert_2}
          </p>
      }
      <div className='ecommerce_divider'/>
      {
        localStorage.getItem('type') != 'free' ?
          <div>
            <p className='ecommerce_input_label'>
              {ecomm.vex_receive} {props.currency === "usd" ? "V-USD" : "V-MXN"} {ecomm.vex_receive2}
              <OverlayTrigger overlay={
              <Tooltip id="tooltip-disabled">
                {ecomm.info_fee} <br/>
                {props.currency === "usd" ? "V-USD" : "V-MXN"} {ecomm.info_fee2} {`${props.vex_fee}%`} {ecomm.info_fee3}
              </Tooltip>}>
              <span className="d-inline-block">
                <Image src={InfoIcon} width={20} style={{marginLeft: 10}}/>
              </span>
            </OverlayTrigger>
            </p>
            <div className='space-between'>
              <div
                className={optionStyle(auto_vex,'enabled')}
                onClick={()=>changeVEX('enabled')}
                >
                {ecomm.auto.enabled}
              </div>
              <div
                className={optionStyle(auto_vex,'disabled')}
                onClick={()=>changeVEX('disabled')}
                >
                {ecomm.auto.disabled}
              </div>
              <div style={{width:150}}/>
            </div>
          </div>
        :
          <p className='ecommerce_input_label'>
            {ecomm.vex_alert}
            <a target="_blank" href={'/kyc'}>{ecomm.kyc}</a>
          </p>
      }

    </>
  )
}

export default ecommOptions;
